// English translation file
export default {
  // Locale code for date formatting
  locale: "en-US",
  
  // Home page
  home: {
    hero: {
      title: "Course Review Hub",
      subtitle:
        "New semester starting?\nNot sure which courses to pick?\nCheck out what everyone thinks!",
      getStarted: "Get Started",
      browseCourses: "Browse Courses",
      registerNow: "Sign Up 100% Free",
    },
    stats: {
      courses: "Courses",
      reviews: "Reviews",
      users: "Users",
    },
    userJourney: {
      title: "Two Ways to Get Unlimited Access",
      subtitle:
        "Choose your path to unlock full premium features and help the community grow",
      or: "OR",
      premiumOffer: {
        title: "🎁 Choose Your Path to Premium Access",
        description:
          "Write reviews to get 30 days at a time, or invite friends for a full year of unlimited access!",
      },
      pathReview: {
        title: "Write Reviews",
        description:
          "Share your course experience and get 30 days of unlimited access for each review you write.",
        benefit: "30 Days per Review",
        step1: "Sign Up Free",
        step2: "Find Your Course",
        step3: "Write & Get Access",
        action: "Start Writing",
      },
      pathInvite: {
        title: "Invite a Friend",
        description:
          "Invite a friend to join. When they write their first review, you both get 1 YEAR of premium access!",
        benefit: "1 Year for Both Users",
        step1: "Sign Up Free",
        step2: "Share Invite Code",
        step3: "Both Get 1 Year",
        action: "Get Invite Code",
      },
      step1: {
        title: "Join the Community",
        description:
          "Create your account to unlock all features and connect with fellow students - completely free!",
        action: "Sign Up 100% Free",
      },
      step2: {
        title: "Browse Courses",
        description:
          "Browse through thousands of courses from German universities with powerful search filters",
        action: "Browse Courses",
      },
      step3: {
        title: "Read Real Reviews",
        description:
          "Get honest insights from students who actually took the courses you're considering",
        limitNote:
          "⚠️ Limited to 10 reviews without contributing - Write reviews to unlock unlimited access",
        action: "View Reviews",
      },
      step4: {
        title: "Share & Get 30 Days Free",
        description:
          "Each review gives you 30 days unlimited access - write reviews regularly to stay free forever!",
        benefit: "30 Days per Review",
        action: "Write Review",
      },
      demo: {
        title: "See How It Works",
      },
    },
    features: {
      title: "Why Choose KursKompass?",
      subtitle:
        "Everything you need to make informed course decisions, all in one place",
      authentic: {
        title: "Authentic Reviews",
        description:
          "Course ratings from real students to help you understand the actual course experience",
      },
      search: {
        title: "Smart Search",
        description:
          "Powerful search functionality to quickly find the course information you need",
      },
      analysis: {
        title: "Data Analysis",
        description:
          "Detailed statistics and charts to help you make informed course selection decisions",
      },
      community: {
        title: "Active Community",
        description:
          "Join thousands of students sharing knowledge and helping each other succeed",
      },
    },
    popularCourses: {
      title: "Popular Courses",
      reviewsLabel: "reviews",
      noData: "No popular course data available",
    },
    quickStart: {
      title: "Quick Start",
      step1: {
        title: "Create Account",
        description:
          "Create your personal account to start using platform features",
        action: "Register Now",
      },
      step2: {
        title: "Browse Courses",
        description:
          "View university and course lists to find courses that interest you",
        action: "Browse Courses",
      },
      step3: {
        title: "Read Reviews",
        description:
          "Read course reviews from other students to understand course details",
        action: "View Statistics",
      },
      step4: {
        title: "Share Experience",
        description: "Submit reviews for your courses to help other students",
        action: "Start Reviewing",
      },
    },
  },

  // Common
  common: {
    search: "Search",
    login: "Login",
    logout: "Logout",
    register: "Register",
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    loading: "Loading...",
    success: "Success",
    error: "Error",
    warning: "Warning",
    info: "Information",
    home: "Home",
    back: "Back",
    next: "Next",
    previous: "Previous",
    yes: "Yes",
    no: "No",
    active: "Active",
    ok: "OK",
    notAvailable: "N/A",
    close: "Close",
    refresh: "Refresh",
    reset: "Reset",
    clear: "Clear",
    selectAll: "Select All",
    deselectAll: "Deselect All",
    language: "Language",
    anonymousUser: "Anonymous User",
    theme: "Theme",
    settings: "Settings",
    help: "Help",
    about: "About",
    contact: "Contact",
    feedback: "Feedback",
    version: "Version",
    update: "Update",
    download: "Download",
    upload: "Upload",
    import: "Import",
    export: "Export",
    print: "Print",
    share: "Share",
    copy: "Copy",
    paste: "Paste",
    cut: "Cut",
    undo: "Undo",
    redo: "Redo",
    footerDescription: "German University Course Review Platform",
    showLess: "Show Less",
    readMore: "Read More",
    skipForNow: "Skip for now",
    bookmarked: "Bookmarked",
    remove: "Remove",
    retry: "Retry",
    retrySuccess: "Retry successful",
    retryFailed: "Retry failed, please try again later",
    backToHome: "Back to Home",
    since: "Since",
    today: "Today",
    yesterday: "Yesterday",
    daysAgo: "{days} days ago",
    loadError: "Failed to load data",
  },

  // Navigation
  nav: {
    title: "KursKompass",
    home: "Home",
    courses: "Courses",
    universities: "Universities",
    reviews: "Reviews",
    recommendations: "Recommendations",
    stats: "Statistics",
    trending: "Trending",
    profile: "Profile",
    settings: "Settings",
    login: "Login",
    register: "Register",
    logout: "Logout",
    addCourse: "Add Course",
    myInvitationCode: "My Invitation Code",
    cancel: "Cancel",
    logoutConfirmMessage: "Are you sure you want to logout?",
    logoutConfirmTitle: "Logout Confirmation",
    logoutConfirm: "Logout",
    logoutSuccess: "Successfully logged out",
  },

  // Trending Page
  trending: {
    subtitle: "Discover the most popular and highest-rated courses at your university",
    topRated: "Top Rated Courses",
    mostReviewed: "Most Reviewed Courses",
    avgRatingSort: "Sorted by Average Rating",
    reviewCountSort: "Sorted by Review Count",
    noData: "No courses available yet",
    noUniversity: "No University Selected",
    noUniversityDesc: "Please select your university from your profile to view trending courses",
    pleaseSelectUniversity: "Please select a university first",
  },

  // Authentication
  auth: {
    welcome: "Welcome to KursKompass",
    login: {
      title: "Sign In",
      welcomeBack: "Welcome Back",
      subtitle: "Login to your KursKompass account",
      username: "Username",
      password: "Password",
      usernamePlaceholder: "Username or Email",
      passwordPlaceholder: "Password",
      loginButton: "Login",
      rememberMe: "Remember me",
      forgotPassword: "Forgot Password?",
      noAccount: "Don't have an account?",
      registerNow: "Register Now",
      platformTitle: "German University Course Rating Platform",
      platformDescription:
        "Transparent and authentic course ratings to help you make better course selection decisions",
      features: {
        authentic: "Authentic Reviews",
        search: "Smart Search",
        analysis: "Data Analysis",
      },
      loginSuccess: "Login successful",
      loginFailed: "Login failed",
      emailVerifiedSuccess: "Email verified successfully! You can now login.",
      emailVerificationFailed:
        "Email verification failed. Please try again or contact support.",
      emailNotVerifiedTitle: "Email Not Verified",
      emailNotVerifiedMessage:
        "Your email is not verified yet. Please verify your email before logging in. Would you like to resend the verification email?",
      resendButton: "Resend",
      laterButton: "Later",
      validationError: "Please check your input and try again",
      validation: {
        usernameRequired: "Please enter username or email",
        usernameLength:
          "Username/Email length should be between 3 and 50 characters",
        passwordRequired: "Please enter password",
        passwordLength: "Password length should not be less than 6 characters",
      },
    },
    forgotPassword: {
      title: "Forgot Password",
      subtitle: "Enter your email address and we'll help you reset your password",
      emailPlaceholder: "Enter your email",
      submitButton: "Send Reset Instructions",
      backToLogin: "Back to Login",
      successMessage: "If an account exists with this email, you will receive password reset instructions shortly.",
      infoTitle: "Password Reset Information",
      infoMessage: "Currently, password reset functionality is in development. Please contact support if you need to reset your password.",
      validation: {
        emailRequired: "Please enter your email address",
        emailInvalid: "Please enter a valid email address",
      },
    },
    register: {
      title: "Join the Smart Course Choosers",
      subtitle: "Don't pick courses blindly - let our community be your guide!",
      username: "Username",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      invitationCode: "Invitation Code (Optional)",
      invitationCodeHint: "Have an invitation code? Enter it to get 1 year of premium access for both you and your friend!",
      validate: "Validate",
      validating: "Validating...",
      hasAccount: "Already have an account?",
      loginNow: "Sign in now",
    },
    loginTitle: "Sign In",
    registerTitle: "Join the Smart Course Choosers",
    registerSubtitle:
      "Don't pick courses blindly - let our community be your guide!",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    signUp: "Sign up",
    signIn: "Sign in",
    loginNow: "Sign in now",
    username: "Username",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    fullName: "Full Name",
    firstName: "First Name",
    lastName: "Last Name",
    phoneNumber: "Phone Number",
    dateOfBirth: "Date of Birth",
    gender: "Gender",
    male: "Male",
    female: "Female",
    other: "Other",
    loginSuccess: "Login successful",
    loginFailed: "Login failed",
    registerSuccess: "Registration successful",
    registerFailed: "Registration failed",
    logoutSuccess: "Logout successful",
    confirmLogout: "Are you sure you want to logout?",
    sessionExpired: "Session expired, please login again",
    accessDenied: "Access denied",
    networkError:
      "Network connection failed, please check your network settings",
  },

  // Search
  search: {
    title: "Search",
    placeholder: "Search courses, universities...",
    searchResults: "Search Results",
    noResults: "No results found",
    popularSearches: "Popular Searches",
    pleaseEnterSearchTerm: "Please enter search term",
    searchFor: "Search for",
    filterByType: "Filter by Type",
    filterByUniversity: "Filter by University",
    sortBy: "Sort by",
    relevance: "Relevance",
    newest: "Newest",
    oldest: "Oldest",
    rating: "Rating",
    name: "Name",
    results: "results",
    found: "found",
    suggestions: "Suggestions",
    history: "Search History",
    clearHistory: "Clear History",
    course: "Course",
    university: "University",
    courseCode: "Course Code",
    other: "Other",
  },

  // Universities
  universities: {
    title: "Universities",
    subtitle: "Browse all German universities",
    name: "University Name",
    location: "Location",
    city: "City",
    state: "State",
    established: "Established",
    type: "Type",
    ranking: "Ranking",
    website: "Website",
    description: "Description",
    students: "Students",
    faculty: "Faculty",
    programs: "Programs",
    tuition: "Tuition",
    admissionRate: "Admission Rate",
    graduationRate: "Graduation Rate",
    search: "Search universities...",
    searchPlaceholder: "Search by university name...",
    cityPlaceholder: "Select city",
    statePlaceholder: "Select state",
    filterByType: "Filter by Type",
    filterByLocation: "Filter by Location",
    filterByRanking: "Filter by Ranking",
    public: "Public",
    private: "Private",
    technical: "Technical",
    liberal: "Liberal Arts",
    research: "Research",
    comprehensive: "Comprehensive",
    viewDetails: "View Details",
    viewCourses: "View Courses",
    moreInfo: "More Information",
    contact: "Contact",
    apply: "Apply",
    favorites: "Favorites",
    addToFavorites: "Add to Favorites",
    removeFromFavorites: "Remove from Favorites",
    compare: "Compare",
    addToCompare: "Add to Compare",
    removeFromCompare: "Remove from Compare",
    clearFilters: "Clear Filters",
    searchButton: "Search",
    coursesAvailable: "{count} courses available",
    coursesAvailableSingular: "{count} course available",
    noData: "No university data available",
    showingResults: "Showing {count} universities",
    showingResultsSingular: "Showing {count} university",
    details: {
      name: "Name",
      totalCourses: "Total Courses",
    },
    noResults: "No universities found",
    loading: "Loading universities...",
  },

  // University Selection
  university: {
    selectYourUniversity: "Select Your University",
    searchPlaceholder: "Search by name, city, or abbreviation (e.g., TUM, RWTH, LMU)...",
    searchHint: "💡 Try searching by abbreviation like TUM, RWTH, KIT, or FH",
    selectionHint:
      "Please select your university. This helps us show you relevant courses.",
    coursesAvailable: "{count} courses available",
    noResults: "No universities found",
    fetchError: "Failed to load universities",
    selectionSuccess: "University selected successfully",
    selectionFailed: "Failed to select university",
    skipForNow: "Skip for now",
  },

  // University Switcher
  universitySwitcher: {
    selectUniversity: "Select University",
    searchPlaceholder: "Search...",
    current: "Current University",
    switchTo: "Switch to",
    viewAll: "View All Universities",
    clearSelection: "Clear Selection",
    noResults: "No universities found",
  },

  // Courses
  courses: {
    title: "Courses",
    subtitle: "Real students, real reviews, real smart choices",
    name: "Course Name",
    code: "Course Code",
    credits: "Credits",
    semester: "Semester",
    year: "Year",
    instructor: "Instructor",
    department: "Department",
    description: "Description",
    prerequisites: "Prerequisites",
    difficulty: "Difficulty",
    workload: "Workload",
    rating: "Rating",
    reviews: "Reviews",
    enrollment: "Enrollment",
    capacity: "Capacity",
    schedule: "Schedule",
    location: "Location",
    textbook: "Textbook",
    syllabus: "Syllabus",
    searchPlaceholder: "Search courses...",
    filterByDepartment: "Filter by Department",
    filterByCredits: "Filter by Credits",
    filterByDifficulty: "Filter by Difficulty",
    filterBySemester: "Filter by Semester",
    easy: "Easy",
    medium: "Medium",
    hard: "Hard",
    veryHard: "Very Hard",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    expert: "Expert",
    spring: "Spring",
    summer: "Summer",
    fall: "Fall",
    winter: "Winter",
    viewDetails: "View Details",
    enroll: "Enroll",
    unenroll: "Unenroll",
    addToWishlist: "Add to Wishlist",
    removeFromWishlist: "Remove from Wishlist",
    shareLink: "Share Link",
    reportIssue: "Report Issue",
  },

  // Add Course
  addCourse: {
    title: "Add Course",
    subtitle: "Can't find your course? Add it and write the first review!",
    form: {
      university: "University",
      universityPlaceholder: "Select University",
      courseName: "Course Name",
      courseNamePlaceholder: "e.g., Introduction to Computer Science",
      courseCode: "Course Code",
      courseCodePlaceholder: "e.g., CS101, MATH200",
      department: "Department (Optional)",
      departmentPlaceholder: "e.g., Computer Science, Mathematics",
      credits: "Credits (Optional)",
      level: "Level (Optional)",
      levelPlaceholder: "Select Level",
      levelBachelor: "Bachelor",
      levelMaster: "Master",
      levelPhD: "PhD",
    },
    actions: {
      cancel: "Cancel",
      submit: "Add Course & Write First Review",
    },
    messages: {
      selectUniversity: "Please select a university",
      loadUniversitiesFailed: "Failed to load universities",
      addSuccess: "Course added successfully! Now write your review.",
      addFailed: "Failed to add course",
      duplicateCourse: "This course already exists! Redirecting to existing course...",
    },
  },

  // Reviews
  reviews: {
    title: "Reviews",
    subtitle:
      "Is this course worth it? How's the professor? Heavy workload? Find out here!",
    write: "Write review",
    noCourseReviews: "No reviews found for this course",
    beFirstToReview: "Be the first to review",
    writeReview: "Write Review",
    editReview: "Edit Review",
    deleteReview: "Delete Review",
    rating: "Rating",
    comment: "Comment",
    helpful: "Helpful",
    notHelpful: "Not Helpful",
    report: "Report",
    anonymous: "Anonymous",
    verified: "Verified",
    recent: "Recent",
    popular: "Popular",
    highest: "Highest Rated",
    lowest: "Lowest Rated",
    filterByRating: "Filter by Rating",
    filterByDate: "Filter by Date",
    sortBy: "Sort by",
    newest: "Newest",
    oldest: "Oldest",
    mostHelpful: "Most Helpful",
    leastHelpful: "Least Helpful",
    searchReviews: "Search reviews...",
    reviewCount: "reviews",
    averageRating: "Average Rating",
    ratingDistribution: "Rating Distribution",
    wouldRecommend: "Would recommend",
    wouldNotRecommend: "Would not recommend",
    reviewGuidelines: "Review Guidelines",
    characterLimit: "Character limit",
    remainingCharacters: "characters remaining",
    submissionSuccess: "Review submitted successfully",
    submissionFailed: "Failed to submit review",
    updateSuccess: "Review updated successfully",
    updateFailed: "Failed to update review",
    deleteSuccess: "Review deleted successfully",
    deleteFailed: "Failed to delete review",
    confirmDelete: "Are you sure you want to delete this review?",
    wasHelpful: "Was this review helpful?",
    loginToVote: "Login to vote",
    professorStyle: "Professor Style",
    selectProfessorTags:
      "Select professor style tags that match your experience",
    professorTags: "Professor Tags",
    professorTagsDescription:
      "Please select tags that best match this professor based on your experience",
    selectedTags: "Selected tags ({count})",
    // Reply functionality
    reply: "Reply",
    replies: "Replies",
    repliesCount: "{count} replies",
    replyPlaceholder: "Write a reply...",
    submitReply: "Submit Reply",
    replySubmitted: "Reply submitted successfully",
    replyFailed: "Failed to submit reply",
    replyUpdated: "Reply updated successfully",
    replyUpdateFailed: "Failed to update reply",
    pleaseEnterReply: "Please enter a reply",
    showMoreReplies: "Show more replies",
    deleteReply: "Delete Reply",
    confirmDeleteReply: "Are you sure you want to delete this reply?",
    sendMessage: "Send Message",
    // Anonymous posting
    postAnonymously: "Post anonymously",
    anonymousTooltip: "Your username will be hidden from other users",
    // Vote related
    thankYou: "Thank you for your feedback!",
    thankYouPositive: "Thank you for your positive feedback!",
    voteCanceled: "Vote has been withdrawn",
    voteFailed: "Voting failed",
    cannotVoteOwnReview: "Cannot vote on your own review",
    youFoundThisReview: "You found this review",
    voteHelpful: "helpful",
    voteNotHelpful: "not helpful",
    // Deleted review
    deletedTitle: "This review has been deleted by the user",
    deletedSubtitle: "Replies to this review are still visible below",
    accessControl: {
      limitedCardTitle: "Limited Access",
      limitReachedCardTitle: "Review Limit Reached",
      limitAlertTitle: "Limited access active",
      limitReachedAlertTitle: "Limit reached",
      limitAlertDescription:
        "You can view up to {limit} reviews without contributing. Remaining free views: {remaining}.",
      limitReachedDescription:
        "You have viewed all {limit} reviews available without contributing. Write a review to unlock more access.",
      unlockTitle: "🚀 Unlock full access",
      unlockWriteReviewTitle: "Write a review",
      unlockWriteReviewDescription:
        "Share your course experience and earn 30 days of unlimited access!",
      writeReviewCta: "Write review",
      statusTitle: "Current status",
      reviewsViewedLabel: "Reviews viewed",
      reviewsWrittenLabel: "Reviews written",
      remainingReviewsLabel: "Remaining free reviews",
      premiumCardTitle: "Premium access active",
      premiumAlertTitle: "Unlimited access",
      premiumAlertDescription: "You have unlimited access to all reviews!",
      premiumValidUntil: "Access valid until",
      premiumReviewedThisMonth: "Submitted review this month",
      premiumTotalReviews: "Total reviews",
      encourageCardTitle: "Share your experience",
      encourageDescription:
        "Help other students by sharing your course insights!",
      encourageCta: "Write your first review",
    },
    progressiveLoading: {
      showMore: "Show More Reviews",
      showMoreCount: "({current}/{total})",
      loadHint: "Shows 1 review at a time",
      limitReached: "Review Viewing Limit Reached",
      youViewed: "You have viewed <strong>{count}</strong> reviews (limit: {limit})",
      unlockRemaining: "<strong>{count}</strong> reviews remaining to unlock",
      unlockWriteTitle: "Unlock by Writing a Review",
      unlockWriteDesc: "Write one course review and unlock 30 days of unlimited access",
      writeNowBtn: "Write Review Now",
      freeBadge: "Free · Stackable",
      or: "OR",
      unlockInviteTitle: "Unlock by Inviting Friends",
      unlockInviteDesc: "Invite a friend to register and write a review, you both get 1 year membership",
      getInviteCodeBtn: "Get Invite Code",
      stackableInfo: "Both methods are stackable, unlock days accumulate",
    },
  },

  // Recommendations
  recommendations: {
    title: "Recommendations",
    subtitle: "Join thousands of students making smarter course decisions",
    
    // Header
    smartRecommendations: "Smart Recommendations",
    aiPoweredSubtitle: "AI-powered course suggestions tailored for you",
    recommendationSettings: "Recommendation Settings",
    refreshAll: "Refresh All",
    
    // Engine Status
    recommendationEngine: "Recommendation Engine",
    engineDescription: "AI model trained on {count} user interactions • Last updated: {date}",
    accuracy: "Accuracy",
    confidence: "Confidence",
    
    // Personalized Section
    personalizedForYou: "Personalized For You",
    courses: "courses",
    relevance: "Relevance",
    rating: "Rating",
    difficulty: "Difficulty",
    
    // Sorting
    sortByRelevance: "Sort by Relevance",
    sortByRating: "Sort by Rating",
    sortByDifficulty: "Sort by Difficulty",
    
    // Login Required State
    signInForPersonalized: "Sign in for personalized recommendations",
    signInDescription: "Get AI-powered course suggestions tailored to your interests, academic background, and learning goals.",
    signIn: "Sign In",
    createAccount: "Create Account",
    or: "or",
    browsePopular: "Browse Popular Courses",
    
    // Login Benefits
    benefits: {
      smartAI: "Smart AI recommendations based on your profile",
      trackProgress: "Track your learning progress and preferences",
      discoverCourses: "Discover courses matching your level",
    },
    
    // Trending Section
    trendingNow: "Trending Now",
    growth: "Growth",
    match: "Match",
    
    // Top Rated Section  
    topRated: "Top Rated",
    reviews: "reviews",
    
    // Because You Viewed Section
    becauseYouViewed: "Because you viewed",
    basedOnHistory: "Based on your browsing history",
    youViewed: "You viewed",
    similarCourses: "Similar Courses",
    viewDetails: "View Details",
    excellentMatch: "Excellent Match",
    greatMatch: "Great Match",
    goodMatch: "Good Match",
    
    // Settings Dialog
    settings: {
      title: "Recommendation Settings",
      focus: "Recommendation Focus",
      balanced: "Balanced",
      popular: "Popular Courses",
      challenging: "Challenging Courses",
      easy: "Easy Courses",
      difficultyPreference: "Difficulty Preference",
      difficultyLevels: {
        easy: "Easy",
        medium: "Medium",
        hard: "Hard",
      },
      subjectInterests: "Subject Interests",
      subjects: {
        computerScience: "Computer Science",
        mathematics: "Mathematics",
        engineering: "Engineering",
        business: "Business",
        languages: "Languages",
      },
      cancel: "Cancel",
      save: "Save Settings",
      saved: "Settings saved",
    },
    
    // Empty States
    noPersonalizedRecommendations: "No personalized recommendations available",
    explorePopularCourses: "Explore Popular Courses",
    
    // Success Messages
    allRecommendationsRefreshed: "All recommendations refreshed",
    recommendationDismissed: "Recommendation dismissed",
    addedToWishlist: "Course added to wishlist!",
    
    // Legacy translations (keep for backward compatibility)
    forYou: "For You",
    trending: "Trending",
    popular: "Popular",
    similar: "Similar",
    basedOnRatings: "Based on Your Ratings",
    basedOnFavorites: "Based on Your Favorites",
    recommendedCourses: "Recommended Courses",
    recommendedUniversities: "Recommended Universities",
    whyRecommended: "Why recommended?",
    because: "Because you",
    viewed: "viewed",
    rated: "rated",
    favorited: "favorited",
    enrolled: "enrolled in",
    searched: "searched for",
    similar_users: "Users with similar interests also liked",
    matching_criteria: "matches your criteria",
    high_rating: "has high ratings",
    popular_choice: "is a popular choice",
    refreshRecommendations: "Refresh Recommendations",
    noRecommendations: "No recommendations available",
    improveRecommendations: "Improve Recommendations",
    feedback: "Feedback",
    feedbackHelpful: "Helpful",
    feedbackNotHelpful: "Not Helpful",
    irrelevant: "Irrelevant",
    alreadyKnown: "Already Known",
    notInterested: "Not Interested",
    thankYou: "Thank you for your feedback!",
    
    personal: {
      title: "Personal Recommendations",
      description: "Based on your preferences and ratings",
    },
  },

  // Statistics
  stats: {
    title: "Statistics",
    overview: "Overview",
    analytics: "Analytics",
    reports: "Reports",
    dashboard: "Dashboard",
    totalUsers: "Total Users",
    totalCourses: "Total Courses",
    totalUniversities: "Total Universities",
    totalReviews: "Total Reviews",
    activeUsers: "Active Users",
    newRegistrations: "New Registrations",
    courseEnrollments: "Course Enrollments",
    averageRating: "Average Rating",
    topRatedCourses: "Top Rated Courses",
    topRatedUniversities: "Top Rated Universities",
    mostPopularCourses: "Most Popular Courses",
    mostPopularUniversities: "Most Popular Universities",
    userActivity: "User Activity",
    searchTrends: "Search Trends",
    geographicDistribution: "Geographic Distribution",
    timeRange: "Time Range",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    last3Months: "Last 3 Months",
    lastYear: "Last Year",
    allTime: "All Time",
    exportData: "Export Data",
    generateReport: "Generate Report",
    downloadReport: "Download Report",
    viewFullReport: "View Full Report",
    noData: "No data available",
    loadingData: "Loading data...",
    refreshData: "Refresh Data",
  },

  // Errors
  errors: {
    general: "An error occurred",
    network: "Network error",
    timeout: "Request timeout",
    unauthorized: "Unauthorized access",
    forbidden: "Access forbidden",
    notFound: "Page not found",
    serverError: "Server error",
    validationError: "Validation error",
    unknownError: "Unknown error",
    tryAgain: "Please try again",
    contactSupport: "Contact support",
    goBack: "Go back",
    reload: "Reload page",
    // Error Boundary
    defaultTitle: "Something went wrong",
    defaultMessage: "The system encountered an unexpected error, please try again later",
    networkTitle: "Network Connection Issue",
    networkMessage: "Unable to connect to the server, please check your network connection",
    notFoundTitle: "Page Not Found",
    notFoundMessage: "The requested resource does not exist, it may have been moved or deleted",
    permissionTitle: "Permission Denied",
    permissionMessage: "You don't have permission to access this resource, please log in again",
  },

  // Form validation
  validation: {
    required: "This field is required",
    email: "Please enter a valid email address",
    password: "Password must be at least 6 characters",
    confirmPassword: "Passwords do not match",
    username: "Username must be 3-20 characters",
    phoneNumber: "Please enter a valid phone number",
    url: "Please enter a valid URL",
    number: "Please enter a valid number",
    integer: "Please enter a valid integer",
    decimal: "Please enter a valid decimal number",
    date: "Please enter a valid date",
    time: "Please enter a valid time",
    minLength: "Minimum length is {min} characters",
    maxLength: "Maximum length is {max} characters",
    minValue: "Minimum value is {min}",
    maxValue: "Maximum value is {max}",
    pattern: "Invalid format",
    unique: "This value already exists",
    fileSize: "File size must be less than {size}",
    fileType: "Invalid file type",
    imageFormat: "Invalid image format",
  },

  // Pagination
  pagination: {
    page: "Page",
    of: "of",
    pages: "pages",
    items: "items",
    showing: "Showing",
    to: "to",
    total: "total",
    first: "First",
    last: "Last",
    previous: "Previous",
    next: "Next",
    goTo: "Go to page",
    itemsPerPage: "Items per page",
    showAll: "Show all",
  },

  // Date and time
  date: {
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    thisWeek: "This week",
    lastWeek: "Last week",
    nextWeek: "Next week",
    thisMonth: "This month",
    lastMonth: "Last month",
    nextMonth: "Next month",
    thisYear: "This year",
    lastYear: "Last year",
    nextYear: "Next year",
    now: "Now",
    soon: "Soon",
    later: "Later",
    never: "Never",
    always: "Always",
    recently: "Recently",
    ago: "ago",
    in: "in",
    seconds: "seconds",
    minutes: "minutes",
    hours: "hours",
    days: "days",
    weeks: "weeks",
    months: "months",
    years: "years",
    daysAgo: "{count} day ago | {count} days ago",
    weeksAgo: "{count} week ago | {count} weeks ago",
    monthsAgo: "{count} month ago | {count} months ago",
    semester: {
      WS: "Winter Semester",
      SS: "Summer Semester",
    },
  },

  // Theme
  theme: {
    switchToLight: "Switch to light mode",
    switchToDark: "Switch to dark mode",
    lightMode: "Light Mode",
    darkMode: "Dark Mode",
  },

  // About page
  about: {
    title: "About KursKompass",
    subtitle:
      "Empowering students to make informed course decisions through community-driven reviews",
    story: {
      title: "Our Story",
      paragraph1:
        "KursKompass was born from a simple yet powerful idea: students deserve transparent, authentic information about their courses before making important academic decisions.",
      paragraph2:
        "As students ourselves, we experienced the frustration of choosing courses blindly, only to discover later that the teaching style, workload, or content didn't match our expectations. We realized that the collective wisdom of the student community could solve this problem.",
      paragraph3:
        "Today, KursKompass serves thousands of students across German universities, helping them make smarter course choices and build better academic journeys. Our platform continues to evolve based on community feedback and needs.",
    },
    mission: {
      title: "Our Mission",
      transparency: {
        title: "Transparency First",
        description:
          "We believe every student deserves honest, unfiltered insights about courses and professors before making academic commitments.",
      },
      community: {
        title: "Community Driven",
        description:
          "Our platform thrives on student contributions, creating a supportive ecosystem where knowledge and experiences are shared freely.",
      },
      improvement: {
        title: "Continuous Improvement",
        description:
          "We constantly evolve our platform based on user feedback, ensuring we meet the changing needs of the academic community.",
      },
    },
    contact: {
      title: "Get in Touch",
      description:
        "Have suggestions, feedback, or ideas to make KursKompass better? We'd love to hear from you! Your input helps us create a platform that truly serves the student community.",
      email: {
        title: "Email Us",
      },
      feedback: {
        title: "Share Feedback",
        description: "Help us improve by sharing your thoughts and suggestions",
      },
      sendFeedback: "Send Feedback",
    },
    feedback: {
      title: "Send Us Feedback",
      type: "Type",
      subject: "Subject",
      message: "Message",
      email: "Email (optional)",
      subjectPlaceholder: "Brief summary of your feedback",
      messagePlaceholder:
        "Tell us more about your thoughts, suggestions, or issues...",
      emailPlaceholder: "your.email{'@'}example.com",
      types: {
        placeholder: "Select feedback type",
        suggestion: "Suggestion",
        bug: "Bug Report",
        feature: "Feature Request",
        general: "General Feedback",
      },
      submitted:
        "Thank you for your feedback! We will carefully consider your suggestions.",
      successMessage:
        "Thank you for your feedback! We appreciate your input and will review it carefully.",
      errorMessage:
        "Failed to submit feedback. Please try again later.",
    },
  },

  // Footer
  footer: {
    quickLinks: "Quick Links",
    features: "Features",
    aboutContact: "About & Contact",
    aboutUs: "About Us",
    contact: "Contact",
    sendFeedback: "Send Feedback",
    privacy: "Privacy Policy",
    professorProfiles: "Professor Profiles",
    advancedSearch: "Advanced Search",
    allRightsReserved: "All rights reserved.",
  },

  // Bookmarks
  bookmarks: {
    bookmark: "Bookmark",
    bookmarked: "Bookmarked",
    addToBookmarks: "Add to Bookmarks",
    addedSuccess: "Course bookmarked successfully!",
    removedSuccess: "Bookmark removed successfully!",
    alreadyBookmarked: "Course is already bookmarked",
    error: "Failed to update bookmark",
    notes: "Notes",
    notesPlaceholder: "Add your personal notes about this course...",
    editNotes: "Edit Notes",
    notesUpdated: "Notes updated successfully!",
    notesError: "Failed to update notes",
    removeBookmark: "Remove Bookmark",
    contextMenuTitle: "Bookmark Options",
    contextMenuMessage: "What would you like to do with this bookmark?",
    myBookmarks: "My Bookmarks",
    noBookmarks: "No bookmarks yet",
    searchBookmarks: "Search bookmarks...",
    trendingBookmarks: "Trending Bookmarks",
    viewAll: "View All Bookmarks",
    stats: {
      total: "Total Bookmarks",
      recent: "Recent Bookmarks",
      categories: "Top Categories",
    },
  },

  // Follows
  follows: {
    follow: "Follow",
    following: "Following",
    mutual: "Mutual",
    unfollow: "Unfollow",
    followedSuccess: "You are now following {username}!",
    unfollowedSuccess: "You unfollowed {username}",
    alreadyFollowing: "You are already following this user",
    alreadyUnfollowed: "You have already unfollowed this user",
    cannotFollowSelf: "You cannot follow yourself",
    error: "Failed to update follow status",
    user: "user",
    followers: "Followers",
    followersCount: "{count} Followers",
    followingCount: "{count} Following",
    mutualFollows: "Mutual Follows",
    recentFollowers: "Recent Followers",
    noFollowers: "No followers yet",
    noFollowing: "Not following anyone yet",
    stats: {
      following: "Following",
      followers: "Followers",
      mutual: "Mutual",
    },
  },

  // Messages
  messagesPage: {
    title: "Messages",
    tabs: {
      inbox: "Inbox",
      sent: "Sent",
    },
    empty: {
      noMessages: "No messages",
      noSentMessages: "No sent messages",
    },
    actions: {
      markAsRead: "Mark as Read",
      delete: "Delete",
      compose: "Compose Message",
      send: "Send",
      cancel: "Cancel",
      close: "Close",
      reply: "Reply",
    },
    form: {
      receiver: "Receiver",
      receiverPlaceholder: "Enter user ID",
      sendingTo: "Sending to:",
      subject: "Subject",
      subjectPlaceholder: "Enter message subject",
      message: "Message",
      messagePlaceholder: "Enter your message",
      messageSimplePlaceholder: "Type your message here...",
    },
    dialog: {
      composeTitle: "Compose Message",
      composeToUser: "Message to {username}",
      from: "From:",
      to: "To:",
      date: "Date:",
      read: "Read:",
      sentAt: "Sent:",
      content: "Content:",
    },
    confirm: {
      deleteTitle: "Confirm Delete",
      deleteMessage: "Are you sure you want to delete this message?",
      deleteButton: "Delete",
      cancelButton: "Cancel",
    },
    messages: {
      loadFailed: "Failed to load messages",
      sendSuccess: "Message sent successfully",
      sendFailed: "Failed to send message",
      markReadFailed: "Failed to mark message as read",
      markReadSuccess: "Message marked as read",
      deleteSuccess: "Message deleted successfully",
      deleteFailed: "Failed to delete message",
    },
  },

  // Invitation System
  invitation: {
    title: "Invite Friends",
    subtitle: "Invite a friend and when they write their first review, you both get 1 YEAR of premium access!",
    myCode: "My Invitation Code",
    yourCode: "Your Unique Invitation Code",
    myCodeSubtitle: "Share this permanent code with unlimited friends!",
    totalUses: "Total Uses",
    completedReviews: "Completed Reviews",
    usageHistory: "Usage History",
    reviewStatus: "Review Status",
    reviewed: "Reviewed",
    pending: "Pending",
    reviewedAt: "Reviewed At",
    premiumStatus: "Premium Status",
    granted: "Granted",
    generateCode: "Generate Invite Code",
    generating: "Generating...",
    myInvitations: "My Invitation Codes",
    code: "Code",
    statusLabel: "Status",
    createdAt: "Created",
    usedAt: "Used",
    invitee: "Invited User",
    actions: "Actions",
    copyCode: "Copy Code",
    share: "Share",
    shareCode: "Share Code",
    copied: "Copied to clipboard!",
    generated: "Invitation code generated successfully!",
    error: "Failed to generate invitation code",
    noInvitations: "No invitation code yet",
    codeInfo: "This is your permanent invitation code. Share it with as many friends as you want!",
    viewDetails: "View Full Details",
    statusTypes: {
      pending: "Pending",
      used: "Used",
      completed: "Completed (Premium Granted)",
    },
    shareMessage: "Join KursKompass with my invite code: {code}\nWhen you write your first review, we both get 1 year of premium access!",
    howItWorks: {
      title: "How It Works",
      step1: "Your permanent invitation code is ready to share",
      step2: "Share it with unlimited friends",
      step3: "When they register and write their first review",
      step4: "You both get 1 YEAR of premium access!",
    },
  },

  // Premium History
  premium: {
    title: "Premium Access History",
    subtitle: "Track your premium access grants and expiration dates",
    currentStatus: "Current Status",
    active: "Active Premium",
    expired: "Expired",
    expiresOn: "Expires on",
    expiredOn: "Expired on",
    history: "Access History",
    grantedAt: "Granted",
    duration: "Duration",
    source: "Source",
    noHistory: "No premium history yet",
    noPremiumAccess: "No Premium Access",
    noPremiumDescription: "Unlock exclusive features and benefits!",
    unlockFeatures: "Get ad-free experience, priority support, and more",
    writeReview: "Write Review (30 Days)",
    inviteFriend: "Invite Friend (1 Year)",
    stackingInfo: "Premium time stacks! Write reviews and invite friends to accumulate unlimited access time.",
    sources: {
      REVIEW: "Wrote a Review",
      REFERRAL_INVITER: "Friend Joined & Reviewed",
      REFERRAL_INVITEE: "Joined via Invitation",
    },
    durations: {
      month: "30 Days",
      year: "1 Year",
    },
  },

  // Statistics Dashboard
  statsDashboard: {
    title: "Analytics Dashboard",
    subtitle: "Comprehensive insights and statistics",
    refresh: "Refresh",
    dateRange: {
      to: "To",
      startPlaceholder: "Start date",
      endPlaceholder: "End date",
    },
    metrics: {
      totalCourses: "Total Courses",
      totalReviews: "Total Reviews",
      activeUsers: "Active Users",
      avgRating: "Average Rating",
    },
    charts: {
      reviewsOverTime: "Course Reviews Over Time",
      ratingDistribution: "Rating Distribution",
      universityPerformance: "University Performance Comparison",
      topRatedCourses: "Top Rated Courses",
    },
    timeframes: {
      last7Days: "Last 7 days",
      last30Days: "Last 30 days",
      last3Months: "Last 3 months",
      lastYear: "Last year",
    },
    universityMetrics: {
      avgRating: "Avg Rating",
      totalReviews: "Total Reviews",
      totalCourses: "Total Courses",
    },
    activity: {
      title: "Recent Activity",
      filters: {
        all: "All",
        reviews: "Reviews",
        courses: "Courses",
        users: "Users",
      },
      types: {
        courseAdded: "New Course Added",
        highRating: "High Rating Received",
        newUsers: "New User Registration",
      },
      timeAgo: {
        minutesAgo: "{count} minutes ago",
        hoursAgo: "{count} hours ago",
        daysAgo: "{count} days ago",
      },
    },
    messages: {
      refreshSuccess: "Data refreshed successfully",
      refreshError: "Failed to refresh data",
    },
  },

  // Reviews Management
  reviewsPage: {
    title: "My Reviews",
    subtitle: "Manage your course reviews and see your contribution to the community",
    stats: {
      totalReviews: "Total Reviews",
      averageRating: "Average Rating",
      semesters: "Semesters",
    },
    card: {
      title: "Your Reviews",
      searchPlaceholder: "Search your reviews...",
    },
    filters: {
      rating: "Filter by Rating",
      semester: "Filter by Semester",
      sortBy: "Sort by",
      clearFilters: "Clear Filters",
    },
    rating: {
      stars5: "5 Stars",
      stars4: "4 Stars",
      stars3: "3 Stars",
      stars2: "2 Stars",
      stars1: "1 Star",
    },
    semester: {
      winter2024: "2024 Winter",
      summer2024: "2024 Summer",
      winter2023: "2023 Winter",
      summer2023: "2023 Summer",
      winterFull2024: "2024 Winter Semester",
      summerFull2024: "2024 Summer Semester",
      winterFull2023: "2023 Winter Semester",
      summerFull2023: "2023 Summer Semester",
    },
    sort: {
      newest: "Most Recent",
      oldest: "Oldest First",
      highest: "Highest Rating",
      lowest: "Lowest Rating",
    },
    empty: {
      title: "No reviews found",
      action: "Start reviewing courses",
    },
    actions: {
      edit: "Edit",
      delete: "Delete",
    },
    editDialog: {
      title: "Edit Review",
      course: "Course",
      rating: "Rating",
      semester: "Semester",
      semesterPlaceholder: "Select semester",
      comment: "Comment",
      commentPlaceholder: "Update your review...",
      cancel: "Cancel",
      update: "Update Review",
    },
    ratingTexts: {
      terrible: "Terrible",
      bad: "Bad",
      average: "Average",
      good: "Good",
      excellent: "Excellent",
    },
    messages: {
      updateSuccess: "Review updated successfully",
      updateError: "Failed to update review",
      deleteConfirmTitle: "Delete Review",
      deleteConfirmMessage: "Are you sure you want to delete this review?",
      deleteSuccess: "Review deleted successfully",
      deleteError: "Failed to delete review",
    },
  },

  // Email Verification
  emailVerification: {
    title: "Email Verification",
    loading: "Verifying your email...",
    success: {
      title: "Email Verification Successful!",
      message: "Welcome to KursKompass! You can now log in and enjoy all features.",
      action: "Go to Login",
    },
    error: {
      title: "Verification Failed",
      action: "Register Again",
    },
    initial: {
      title: "Email Verification",
      message: "Please check your email and click the verification link to activate your account.",
    },
    resend: {
      prompt: "Didn't receive an email?",
      placeholder: "Enter your email address",
      button: "Resend",
      buttonSending: "Sending...",
      buttonResend: "Resend Verification Email",
      success: "Verification email has been resent. Please check your inbox.",
      error: "Failed to send email. Please try again later.",
      emailRequired: "Please enter your email address",
    },
  },

  // Profile Page
  profilePage: {
    actions: {
      editProfile: "Edit Profile",
      changePassword: "Change Password",
    },
    tabs: {
      info: "Profile Info",
      reviews: "My Reviews",
      invitations: "Invitations",
      premium: "Premium History",
    },
    premiumStatus: {
      title: "Premium Status",
      activeTitle: "⭐ Premium Access Active",
      inactiveTitle: "Unlock Premium Access",
      activeMessage: "You're enjoying full access to all premium features!",
      inactiveMessage: "Write reviews or invite friends to get premium access.",
      expiresOn: "Expires on",
      extendTitle: "Extend Premium Time",
      extendMessage: "Write more reviews or invite friends to extend your premium access!",
      writeReviewButton: "Write Review (+30 Days)",
      inviteFriendButton: "Invite Friend (+1 Year)",
      active: "Premium Access Active",
      validUntil: "Valid until:",
      unlimited: "✓ Unlimited review access",
    },
    personalInfo: {
      title: "Personal Information",
      firstName: "First Name",
      lastName: "Last Name",
      university: "University",
      major: "Major",
      graduationYear: "Graduation Year",
      username: "Username",
      email: "Email",
      totalReviews: "Total Reviews",
      notProvided: "Not provided",
    },
    bio: {
      title: "About Me",
    },
    reviews: {
      title: "My Course Reviews",
      stats: {
        total: "Total Reviews",
        avgRating: "Avg Rating",
      },
      empty: "You haven't written any reviews yet",
      sortBy: "Sort by",
      sortOptions: {
        newest: "Newest First",
        oldest: "Oldest First",
        highest: "Highest Rating",
        lowest: "Lowest Rating",
      },
      actions: {
        edit: "Edit",
        delete: "Delete",
      },
      deleteConfirm: {
        title: "Delete Review",
        message: "Are you sure you want to delete this review?",
      },
    },
    editDialog: {
      title: "Edit Your Profile",
      sections: {
        personal: "Personal Information",
        academic: "Academic Information",
        contact: "Contact Information",
        bio: "Biography",
      },
      fields: {
        firstName: "First Name",
        lastName: "Last Name",
        university: "University",
        major: "Major",
        graduationYear: "Graduation Year",
        email: "Email Address",
        bio: "Bio",
      },
      placeholders: {
        firstName: "Enter first name",
        lastName: "Enter last name",
        university: "Select your university",
        major: "e.g., Computer Science",
        graduationYear: "2025",
        email: "your.email{'@'}example.com",
        bio: "Tell us about yourself... (optional)",
      },
      current: "Current:",
      displayNamePreference: "Display Name Preference",
      displayName: {
        realname: "Real Name",
        username: "Username",
        anonymous: "Anonymous",
        anonymousDesc: "Display as Anonymous User",
      },
      cancel: "Cancel",
      save: "Save",
      saveChanges: "Save Changes",
      messages: {
        updateSuccess: "Profile updated successfully",
        updateError: "Failed to update profile",
      },
    },
    passwordDialog: {
      title: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      cancel: "Cancel",
      change: "Change Password",
      messages: {
        success: "Password changed successfully",
        error: "Failed to change password",
      },
    },
    validation: {
      emailRequired: "Please enter a valid email address",
      yearRequired: "Please enter a valid year",
      currentPasswordRequired: "Please enter current password",
      newPasswordRequired: "Please enter new password",
      confirmPasswordRequired: "Please enter password again",
      passwordMismatch: "Passwords do not match",
    },
  },

  // Add University
  addUniversity: {
    title: "Add University",
    subtitle: "Add a new German university to the platform",
    fields: {
      name: "University Name",
      shortName: "Short Name",
      city: "City",
      state: "State",
      type: "Type",
      established: "Established",
      website: "Website",
      description: "Description",
    },
    placeholders: {
      name: "e.g., Technische Universität München",
      shortName: "e.g., TUM, LMU",
      city: "e.g., München",
      state: "e.g., Bayern",
      type: "Select Type",
      website: "https://www.university.de",
      description: "Brief description of the university, its strengths and characteristics",
    },
    types: {
      full: "Volluniversität",
      technical: "Technische Universität",
      applied: "Fachhochschule",
      art: "Kunsthochschule",
      music: "Musikhochschule",
      sport: "Sporthochschule",
    },
    actions: {
      cancel: "Cancel",
      submit: "Add University",
    },
    validation: {
      nameRequired: "Please enter university name",
      nameLength: "Length should be 2 to 200 characters",
      shortNameRequired: "Please enter short name",
      shortNameLength: "Length should be 2 to 50 characters",
      cityRequired: "Please enter city",
      cityLength: "Length should be 2 to 50 characters",
      stateRequired: "Please enter state",
      stateLength: "Length should be 2 to 50 characters",
      typeRequired: "Please select type",
      establishedRequired: "Please enter establishment year",
      websiteInvalid: "Please enter a valid URL",
      descriptionRequired: "Please enter description",
      descriptionLength: "Length should be 10 to 1000 characters",
    },
    messages: {
      success: "University added successfully!",
      error: "Failed to add university",
    },
  },

  // Monitoring Dashboard
  monitoring: {
    title: "Search Service Monitoring Dashboard",
    checking: "Checking...",
    refresh: "Refresh Data",
    refreshing: "Refreshing...",
    stats: {
      totalSearches: "Total Searches",
      avgResponseTime: "Avg Response Time",
      maxResponseTime: "Max Response Time",
      systemStatus: "System Status",
    },
    popularSearches: {
      title: "Top 10 Popular Searches",
      loading: "Loading...",
      times: "times",
    },
    errors: {
      loadFailed: "Failed to load popular searches",
      refreshFailed: "Data refresh failed",
    },
  },

  // Student Verification
  verification: {
    title: "Verify Student",
    verifyCode: "Verify Code",
    instructions: "Use your university email to verify your status.",
    universityLabel: "University",
    selectUniversity: "Select your university",
    universityRequired: "University is required",
    selectUniversityFirst: "Please select a university",
    loadingDomains: "Loading domains...",
    emailLabel: "University email",
    emailCalloutTitle: "University email",
    emailCalloutSubtitle: "Only allowed domains are accepted.",
    emailPlaceholder: "your.email{'@'}university.edu",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email",
    validDomains: "Valid domains",
    validDomainHint: "This email domain is accepted: {domain}",
    invalidDomainHint: "We do not recognise this email domain yet. Please send feedback to the admins.",
    unknownDomainHint: "We could not match this email domain. Please double-check your address.",
    sendCode: "Send code",
    codeLabel: "Verification code",
    codePlaceholder: "Six digit code",
    codeRequired: "Code is required",
    codeLength: "Code must be six digits",
    verify: "Verify",
    resendCode: "Resend code",
    resendIn: "Resend in {seconds} seconds",
    codeSent: "Code sent to {email}",
    successTitle: "Verification complete",
    successMessage: "Your status is verified.",
    codeSentSuccess: "Code sent successfully",
    verifySuccess: "Verified successfully",
    resendSuccess: "Code resent successfully",
    loadUniversitiesError: "Failed to load universities",
    sendCodeError: "Failed to send code",
    verifyError: "Failed to verify",
    resendError: "Failed to resend code",
    verifiedStudent: "Verified student",
    verifyStudentStatus: "Verify student status",
  },

  // User preview card
  userPreview: {
    reviews: "Reviews",
    followers: "Followers",
    likes: "Likes",
    message: "Message",
    viewProfile: "View Profile",
    loadFailed: "Failed to load user info",
  },

  // User profile page
  userProfile: {
    overview: "Overview",
    reviews: "Reviews",
    activity: "Activity",
    bio: "Bio",
    major: "Major",
    graduationYear: "Graduation Year",
    joinedDate: "Joined",
    followersCount: "Followers",
    followingCount: "Following",
    reviewsCount: "Reviews",
    totalUpvotes: "Total Likes",
    likes: "Likes",
    noBio: "This user hasn't written a bio yet.",
    noBioOwn: "You haven't written a bio yet. Click 'Add Bio' to introduce yourself!",
    noReviews: "No reviews yet.",
    loadError: "Failed to load user profile",
    courseName: "Course",
    semester: "Semester",
    viewCourse: "View Course",
    editBio: "Edit Bio",
    addBio: "Add Bio",
    bioPlaceholder: "Tell others about yourself...",
    bioUpdateSuccess: "Bio updated successfully",
    bioUpdateFailed: "Failed to update bio",
    verifiedStudent: "Verified Student",
  },

  // Review Filter
  reviewFilter: {
    title: "Filter & Sort Reviews",
    clearAll: "Clear All",
    rating: "Rating",
    anyRating: "Any Rating",
    star: "star | stars",
    semester: "Semester",
    anySemester: "Any Semester",
    sortBy: "Sort By",
    mostRecent: "Most Recent",
    highestRating: "Highest Rating",
    lowestRating: "Lowest Rating",
    mostHelpful: "Most Helpful",
    searchReviews: "Search Reviews",
    searchPlaceholder: "Search in review comments...",
    reviewLength: "Review Length",
    anyLength: "Any Length",
    shortReviews: "Short Reviews (< 100 chars)",
    mediumReviews: "Medium Reviews (100-300 chars)",
    longReviews: "Long Reviews (> 300 chars)",
    verifiedStudents: "Verified Students",
    onlyVerified: "Only Verified",
    allReviews: "All Reviews",
    hide: "Hide",
    show: "Show",
    advancedFilters: "Advanced Filters",
    activeFilters: "Active filters",
    verifiedStudentsOnly: "Verified Students Only",
  },

  // Courses Page
  coursesPage: {
    title: "Course Discovery",
    subtitle: "Discover courses with our advanced search and filtering system",
    universityTip: "💡 Select your university in the search filters below to see personalized course recommendations",
    addCourseHint: "Can't find your course? Add it and share your first review!",
    addCourse: "Add Course",
    coursesFound: "{count} courses found",
    showingResults: "Showing results for your search and filters",
    grid: "Grid",
    list: "List",
    noCourses: "No courses found",
    noCoursesDescription: "No courses found matching your criteria",
    noCoursesSubtitle: "Try adjusting your search filters, or check out the hint above to add a new course!",
    clearFilters: "Clear Filters",
    courseCode: "Course Code",
    viewDetails: "View Details",
    viewReviews: "View Reviews",
  },

  // Review Statistics
  reviewStats: {
    title: "Review Statistics",
    reviewsCount: "{count} reviews",
    ratingDistribution: "Rating Distribution",
    averageRating: "Average Rating",
    totalReviews: "Total Reviews",
    recommend: "Recommend",
    overallRating: "Overall Rating",
    courseCharacteristics: "Course Characteristics",
    difficulty: "Difficulty",
    workload: "Workload",
    teaching: "Teaching",
    courseRatingQuality: "Course Rating Quality",
    difficultyLabels: {
      veryEasy: "Very Easy",
      easy: "Easy",
      moderate: "Moderate",
      challenging: "Challenging",
      veryChallenging: "Very Challenging",
    },
    workloadLabels: {
      veryLight: "Very Light",
      light: "Light",
      moderate: "Moderate",
      heavy: "Heavy",
      veryHeavy: "Very Heavy",
    },
    teachingLabels: {
      poor: "Poor",
      fair: "Fair",
      good: "Good",
      veryGood: "Very Good",
      excellent: "Excellent",
    },
    qualityLabels: {
      excellent: "Excellent",
      veryGood: "Very Good",
      good: "Good",
      average: "Average",
      belowAverage: "Below Average",
      poor: "Poor",
    },
    qualityDescriptions: {
      excellent: "This course consistently receives outstanding ratings from students.",
      veryGood: "This course is highly rated and recommended by most students.",
      good: "This course receives generally positive feedback from students.",
      average: "This course receives mixed reviews from students.",
      belowAverage: "This course has received mostly negative feedback from students.",
      poor: "This course has significant issues according to student feedback.",
    },
  },
};
